import { 
  Camera, 
  Video, 
  Palette, 
  Music, 
  Film, 
  Edit3, 
  Image, 
  Megaphone,
  Sparkles,
  Layers,
  Play,
  Mic
} from 'lucide-react';
import type { Product } from './types';

export const creativeProducts: Product[] = [
  {
    id: 'video-production-suite',
    title: 'Video Production Suite',
    subtitle: 'Complete video creation platform',
    description: 'Professional video production tools with editing, effects, collaboration, and publishing capabilities.',
    icon: Video,
    image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Creative & Media',
    status: 'Available',
    businessTypes: ['#creative-agencies', '#video-production', '#media', '#entertainment', '#marketing'],
    features: [
      'Professional Video Editing & Timeline',
      'Advanced Colour Grading & Effects',
      'Multi-Camera & Multi-Track Editing',
      'Audio Mixing & Sound Design',
      'Collaboration & Review Tools',
      'Export & Publishing Automation',
      'Asset Management & Organisation',
      'Performance Optimisation & Rendering',
      'UK broadcast standards compliance',
      'GDPR media asset protection'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-red-500 to-pink-600'
  },
  {
    id: 'graphic-design-studio',
    title: 'Graphic Design Studio',
    subtitle: 'Professional design platform',
    description: 'Comprehensive graphic design tools with templates, collaboration, and brand management capabilities.',
    icon: Palette,
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Creative & Media',
    status: 'Available',
    businessTypes: ['#creative-agencies', '#design-studios', '#marketing', '#small-business', '#freelancers'],
    features: [
      'Professional Design Tools & Canvas',
      'Template Library & Brand Assets',
      'Vector & Raster Graphics Support',
      'Typography & Font Management',
      'Collaboration & Feedback System',
      'Brand Guidelines & Style Management',
      'Export & Print Optimisation',
      'Client Portal & Project Management',
      'UK design standards compliance',
      'GDPR client data protection'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-purple-500 to-indigo-600'
  },
  {
    id: 'photography-management',
    title: 'Photography Management System',
    subtitle: 'Complete photography business solution',
    description: 'End-to-end photography business management with client management, booking, editing, and delivery.',
    icon: Camera,
    image: 'https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Creative & Media',
    status: 'Available',
    businessTypes: ['#photography', '#creative-agencies', '#events', '#weddings', '#portraits'],
    features: [
      'Client Management & Booking System',
      'Photo Editing & Enhancement Tools',
      'Gallery Management & Client Delivery',
      'Contract & Invoice Management',
      'Shoot Planning & Location Tracking',
      'Equipment Management & Maintenance',
      'Social Media Integration & Marketing',
      'Business Analytics & Reporting'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-blue-500 to-cyan-600'
  },
  {
    id: 'audio-production-suite',
    title: 'Audio Production Suite',
    subtitle: 'Professional audio creation platform',
    description: 'Comprehensive audio production tools with recording, mixing, mastering, and collaboration features.',
    icon: Music,
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Creative & Media',
    status: 'Available',
    businessTypes: ['#music-production', '#podcasting', '#audio-post', '#media', '#entertainment'],
    features: [
      'Multi-Track Recording & Editing',
      'Virtual Instruments & Sound Libraries',
      'Audio Effects & Processing',
      'Mixing & Mastering Tools',
      'Collaboration & Version Control',
      'Audio Analysis & Visualization',
      'Export & Distribution Integration',
      'Client Review & Approval System'
    ],
    pricing: { setup: 40000, monthly: 1840 },
    color: 'from-green-500 to-teal-600'
  },
  {
    id: 'digital-asset-management',
    title: 'Digital Asset Management Platform',
    subtitle: 'Comprehensive media organisation',
    description: 'Advanced digital asset management with AI-powered tagging, version control, brand compliance, and distribution workflows.',
    icon: Layers,
    image: 'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Creative & Media',
    status: 'Available',
    businessTypes: ['#creative-agencies', '#marketing', '#media', '#brand-management', '#digital-assets'],
    features: [
      'AI-Powered Asset Tagging & Search',
      'Version Control & Asset History',
      'Brand Compliance & Guidelines',
      'Automated Workflow & Approvals',
      'Rights Management & Licensing',
      'Multi-Format Support & Conversion',
      'Cloud Storage & CDN Integration',
      'Usage Analytics & Reporting',
      'Collaboration & Sharing Tools',
      'Integration with Creative Software',
      'Mobile Access & Preview',
      'Custom Metadata & Taxonomy'
    ],
    pricing: { setup: 45000, monthly: 2070 },
    color: 'from-indigo-500 to-purple-600'
  }
];
